import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, map } from 'rxjs';
import { PopupComponent, Popup } from './popup.component';


@Injectable({
  providedIn: 'root'
})
export class PopupService {
  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);

  open(content: Popup) {
    if (this.dialog.openDialogs.length > 0) {
      return;
    }
    const ref = this.dialog.open(PopupComponent, { data: content });
    if (content.duration) {
      setTimeout(() => ref.close(), content.duration);
    }
    return ref;
  }

  /**
   * Opens a popup whose title and message are translated from an i18n key
   * prefix — `${keyPrefix}.title` / `${keyPrefix}.message`. `params` is passed
   * to both translations; remaining Popup fields (duration, link, ...) pass
   * through unchanged.
   */
  notify(keyPrefix: string, extras?: Partial<Omit<Popup, 'title' | 'message'>> & { params?: Record<string, unknown> }) {
    const { params, ...rest } = extras ?? {};
    return this.open({
      title: this.translate.instant(`${keyPrefix}.title`, params),
      message: this.translate.instant(`${keyPrefix}.message`, params),
      ...rest,
    });
  }

  /**
   * Opens a confirmation popup and resolves to `true` only when the user
   * confirms (the cancel button and backdrop dismissal both resolve `false`).
   */
  confirm(content: Popup): Observable<boolean> {
    const ref = this.dialog.open(PopupComponent, { data: { ...content, confirm: true } });
    return ref.afterClosed().pipe(map(result => result === true));
  }
}
